import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { shallowEqual, useSelector } from 'react-redux';

import { ActionTimeControl } from '../../ActionTimeControl/ActionTimeControl';
import { MoreVertIconContrast } from '../../../icons/MoreVertIconContrast';
import Landing from '../../../icons/image/Landing';
import { getCurrentSendedLanding, getPreviewWorkTime } from '../../../selectors/sended-data';
import { checkTimeIsCorrect } from '../../../service/NavPointsUtils';

export const LandingTime = memo(({ className, onShowModal, onChangeTime }) => {
    const { flightTime, value } = useSelector((state) => {
        const landing = getCurrentSendedLanding(state);
        const previewWorkTime = getPreviewWorkTime(state);

        return {
            value: landing.landingTime,
            flightTime: previewWorkTime.flightTime,
        };
    }, shallowEqual);
    const { t: translate } = useTranslation();

    const landingSummary = React.useMemo(() => {
        return [
            {
                title: translate('flightInfoPage.flightTime'),
                value: flightTime,
                isCorrect: checkTimeIsCorrect(flightTime),
            },
        ];
    }, [flightTime, translate]);

    return (
        <ActionTimeControl
            title={translate('flightInfoPage.landingTime')}
            buttonName={translate('flightInfoPage.landing')}
            iconButton={<Landing width="30" height="30" />}
            iconMenuImg={<MoreVertIconContrast isContrast={true} />}
            text={translate('flightInfoPage.aircraftLandedOn')}
            name="landingTime"
            value={value}
            summary={landingSummary}
            onChange={onChangeTime}
            showModal={onShowModal}
            className={className}
        />
    );
});
